import React, { useEffect, useRef } from "react";

export default ({ source, test, children, targetClass = "gos-dt-td", errorClass = "csqa-validationError", containsError = false }) => {
	const ref = useRef();
	useEffect(() => {
		setTimeout(() => {
			ref?.current?.closest(`.${targetClass}`)?.classList?.add(errorClass);
		}, 100);
		return () => {
			if (ref?.current) {
				ref.current = null;
			}
		};
	}, [source, test]);
	return source != test || containsError ? <div ref={ref}>{children}</div> : children;
};
